import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import ModalRowItem from '../ModalRowItem';

import styles from './ModalRowList.module.scss';
import usePresenter from './ModalRowList.presenter';
import getProps from './ModalRowList.props';
import { ModalRowListCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const ModalRowList: React.FC<ModalRowListCombinedProps> = observer((props) => {
  const {
    className,
    classes,
    modalRowItems,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.modalRowList;

  const modalRowItemViews = modalRowItems?.map((modalRowItem, index) => (
    <ModalRowItem
      key={index}
      className={cx(styles.modalRowItem, classes?.modalRowItem)}
      {...internalProps.modalRowItem}
      {...modalRowItem}
    />
  )) || [];

  return (
    <div className={cx(currentStyle, className)}>
      {modalRowItemViews}
    </div>
  );
}); // MANUAL OVERRIDE

export default ModalRowList;
